export default __webpack_public_path__ + "media/images/icons/icon_reply-e0c983a2e64569176501a9e047f91b7e.svg";